import { ImageLoaderProps } from 'next/image';

import { ExternalLink } from '../../../components/Clickables/ExternalLink/ExternalLink';
import { Heading } from '../../../components/Heading/Heading';
import { NextImageWrapper } from '../../../components/NextImage/NextImageWrapper';
import { Text } from '../../../components/Text/Text';
import { GetPage_entry_promotedCallToActions_edges_node as IPromotedCTA } from '../../../interfaces/graphql';
import { getImgProxyLoader } from '../../../helpers/imageLoaders/imgProxy';

interface IProps {
  promotedCallToAction: IPromotedCTA;
}

export const PromotedCallToAction = ({ promotedCallToAction }: IProps) => {
  const { image, buttonText, headline, subHeadline, targetUrl } = promotedCallToAction;

  const imageUrl = image.url || '';
  const imageWidth = image.width || 0;
  const imageHeight = image.height;

  const imgProxyLoader = ({ src, width, quality }: ImageLoaderProps): string =>
    getImgProxyLoader(src, width, imageWidth, imageHeight, { quality });

  return (
    <div className="relative h-[400px] w-full bg-cover bg-center">
      <NextImageWrapper
        alt="promo image"
        wrapperClassName="h-full"
        imageClassName="h-full w-full object-cover"
        src={imageUrl}
        loader={imgProxyLoader}
        fill
        sizes="100vw"
      />
      <div className="absolute bottom-16 left-4">
        <Text className="mb-3 font-semibold text-white">{subHeadline}</Text>
        <Heading className="text-white">{headline}</Heading>
      </div>
      <ExternalLink
        href={targetUrl}
        target="_blank"
        variant="buttonNone"
        className="focus:shadow-outline-white absolute bottom-4 left-4 border-white bg-transparent text-white hover:bg-white hover:text-primary active:bg-white"
      >
        {buttonText}
      </ExternalLink>
    </div>
  );
};
